export function login () {

}

export function loginForOauth () {

}

export function supports(loginMethod) {
    return loginMethod === 'DEALER_ID';
}

export default {
    login,
    supports,
}